module.exports = __webpack_public_path__ + "static/banner-cuadrado-sumate-37fbd5f889b5427d93b7ba1afc8277bb.gif";